import * as React from "react";
import { SVGProps } from "react";

const Sora = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 226 226"
    {...props}
  >
    <style>{".st10{fill:#e3242d}"}</style>
    <path
      d="M43.9 112.9V94.3h59.8V75.2H43.9V56.7h138.2v18.6h-59.8v19.1h59.8V113h-59.8l60.1 89.4c26.6-20.7 43.7-53 43.7-89.3C226.1 50.6 175.5 0 113.1 0 50.6 0 0 50.6 0 113.1c0 36.3 17.1 68.6 43.7 89.3l60.1-89.4c0-.1-59.9-.1-59.9-.1z"
      className="st10"
    />
    <path
      d="M59.2 212.5c16 8.7 34.3 13.6 53.8 13.6s37.8-4.9 53.8-13.6L113 132.3l-53.8 80.2z"
      className="st10"
    />
  </svg>
);

export default Sora;
